import { useCallback, useState, useEffect } from "react"
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap"
import BreadCrumb from "../../Components/BreadCrumb"
import SummarySOB from "./components/SummarySOB"
import StakingSOB from "./pools/StakingSOB"

import { formatNumber, formatAmount } from "../../utils"
import { api } from "../../apis/staking/api"
import sobStakingAbi from "../../abi/StakeTokenFixedLock.json"
import swdtknAbi from "../../abi/SWDTKN.json"

const SobStaking = ({ location }) => {
    const [stakedAmount, setStakedAmount] = useState(0)
    const [stakedByPools, setStakedByPools] = useState({ sob: 0 })
    const [igspApy, setIgspApy] = useState(277)
    const [lastReward, setLastReward] = useState(300000)
    const pools = {
        sob: {
            providerUri: "https://polygon-rpc.com/", //polygon
            explorer: "https://polygonscan.com/tx/", //polygonscan
            chainSymbol: "MATIC",
            poolSymbol: "SOB",
            poolName: "Swords of Blood Staking Pool",
            breadCrumb: "Swords of Blood Staking Pool",
            apy: "Varied%",
            next_deadline: "N/A",
            chainId: 137,
            args: { maxPriorityFeePerGas: "0xba43b74000" },
            stakingContractAddress: "0xaae3ceffbd97e24EeB2c205E122D4F87bE0B53f4", //tbd
            stakingAbi: sobStakingAbi, //sobstakingabi
            timeLock: true,
            multRewards: false,
            tokenContractAddress: "0x968B493a2B27D03Dad92B9eA1e2E8232a72c9C2C", //update
            tokenSymbol: "SWDTKN",
            tokenAbi: swdtknAbi
        }
    }
    const [active, setActive] = useState("")
    const [price, setPrice] = useState(0)
    const [circSupply, setCircSupply] = useState(0)

    // const getCircSupply = async () => {
    //     const data = await api.getCircSupply()
    //     if (data) {
    //         setCircSupply(data)
    //     }
    // }
    // const getPrice = async () => {
    //     const data = await api.getPrice()
    //     if (data) {
    //         setPrice(data["idexo-token"]["usd"])
    //         const usdprice = data["idexo-token"]["usd"]
    //         const apycalc = parseInt(((lastReward * 12) / stakedByPools.igspv2) * 100)
    //         setIgspApy(apycalc)
    //     }
    // }

    const handleStakedAmount = (symbol, staked) => {
        const pool = symbol.toLowerCase()
        stakedByPools[pool] = staked
        setStakedByPools({ ...stakedByPools })
    }

    useEffect(() => {
        let total = 0
        for (const pool of Object.keys(stakedByPools)) {
            total += parseInt(stakedByPools[pool])
        }
        setStakedAmount(total)
    }, [stakedByPools])

    // useEffect(() => {
    //     try {
    //         getCircSupply()
    //         getPrice()
    //     } catch (error) {
    //         console.log(error)
    //     }
    //     return () => {
    //         // clean
    //     }
    // }, [])

    const handleExpanded = useCallback(
        (poolId) => {
            if (poolId === active) {
                setActive("")
            } else {
                setActive(poolId)
            }
        },
        [active]
    )
    const pool = new URLSearchParams(location.search).get("pool")?.toLowerCase()

    switch (pool) {
        case "sob":
            return <StakingSOB pool={pools[pool]} />
        // case "igspv2":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "ibbp":
        //     return <Staking pool={pools[pool]} />
        // case "isip":
        //     return <Staking pool={pools[pool]} />
        // case "itip":
        //     return <Staking pool={pools[pool]} />
        // case "nftme":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "igspvz":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "ghd":
        //     return <StakingFlexLock pool={pools[pool]} />
        // case "dragon":
        //     return <StakingFlexLock pool={pools[pool]} />
        default:
            break
    }

    const marketCap = () => {
        let mc = 0

        if (price && circSupply) {
            mc = parseInt(price * circSupply)
            mc = formatAmount(mc, 2)
        }

        return mc
    }

    return (
        <div className="content stake-page">
            <BreadCrumb items={["Staking Dashboard"]} />
            <div className="stake-body">
                <Card>
                    <CardHeader>
                        <CardTitle className="h3">Swords of Blood Staking</CardTitle>
                    </CardHeader>
                    <CardBody className="dashboard pt-0">
                        <div className="staked-info">
                            <div>
                                <div className="title">Total Staked</div>
                                <div className="value">{formatNumber(stakedAmount.toFixed(0))} SWDTKN</div>
                            </div>

                            <div>
                                <div className="title">Max APY</div>
                                <div className="value">40%</div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <div className="pools-body">
                            <div className="pools-header">
                                <div>Symbol</div>
                                <div>Name</div>
                                <div>Total Staked</div>
                                <div>Est. APY</div>
                                <div>Next Deadline</div>
                            </div>
                            <SummarySOB
                                pool={pools.sob}
                                active={active}
                                onExpand={handleExpanded}
                                handleStakedAmount={handleStakedAmount}
                            ></SummarySOB>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default SobStaking
